import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {CompetitorResultsDetail, CompetitorStageDetail} from '@model';


@Injectable({providedIn: 'root'})
@Pipe({name: 'ltpCompetitorStageDetail'})
export class LtpCompetitorStageDetailPipe implements PipeTransform {

    constructor() {
    }

    transform(competitorResultsDetail?: CompetitorResultsDetail | undefined): CompetitorStageDetail | undefined {
        if (competitorResultsDetail?.ltpCompetitorStageDetail) {
           return competitorResultsDetail.ltpCompetitorStageDetail;
        }
        else {
            return this.getLastTime(competitorResultsDetail?.SGS)
        }
    }

    private getLastTime(sgs: { [key: string]: CompetitorStageDetail } | undefined): CompetitorStageDetail | undefined {
        if (!sgs) return undefined;

        const sorted = Object.values(sgs)
            .filter(detail => !!detail.ps_tm)
            .sort((a, b) => {
                try {
                    const aTime = new Date(a!.ps_tm!.replace(' ', 'T')).getTime();
                    const bTime = new Date(b!.ps_tm!.replace(' ', 'T')).getTime();
                    return bTime - aTime;
                } catch (e) {
                    return 0;
                }
            });

        return sorted[0];
    }
}
